<template>
<section class="logo-grid px-4 py-8">

    <SmoothLoader class="max-w-4xl mx-auto">
        <span v-if="kicker" v-html="kicker" class="kicker font-headline uppercase font-bold text-center text-lg text-primary-500 block"></span>
        <h2 v-if="headline" v-html="headline" class="font-headline text-3xl vt:text-4rem text-center font-bold mb-8 text-primary-700 leading-tight"></h2>
        <div class="flex flex-wrap justify-center -mx-4">
            <div v-for="logo in logos" class="px-4 w-1/2 vt:w-1/3 ht:w-1/5 mb-4">
                <img :src="logo.src" :alt="logo.alt">
            </div>
        </div>
    </SmoothLoader>

</section>
</template>

<script>
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>